import env from '@beam-australia/react-env';

export const downloadFileFromUrl = (url, fileName = null) => {
  if (!url) {
    return;
  }

  const a = document.createElement('a');

  a.style.display = 'none';
  a.href = url;
  a.download = fileName;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const downloadFileFromUrlWithApiKey = (url) => {
  const isDevelopment = env('EXT_TARGET_ENV') === 'development';
  const apiKey = env('EXT_X_API_HEADER');
  const query = isDevelopment && apiKey ? `?apiKey=${apiKey}` : '';
  return downloadFileFromUrl(`${url}${query}`);
};

export const convertDataUrlToFile = (url, fileName, fileType) => {
  return !url
    ? null
    : fetch(url)
        .then((res) => res.blob())
        .then((blob) => new File([blob], fileName, { type: fileType }));
};

export const getFileExtensionFromFileName = (fileName) => {
  fileName = fileName || '';
  const indexOfLastDot = fileName.lastIndexOf('.');
  if (indexOfLastDot === -1) {
    return null;
  }
  return fileName.slice(indexOfLastDot + 1);
};

export const validateFileDimensions = (file, validationConfig) => {
  const { minWidth, minAspectRatio, maxAspectRatio } = validationConfig;

  return getFileDimensions(file).then((result) => {
    const { width, height } = result;

    if (width < minWidth) {
      return false;
    }
    const aspectRatio = width / height;
    if (aspectRatio < minAspectRatio || aspectRatio > maxAspectRatio) {
      return false;
    }
    return true;
  });
};

export const getFileDimensions = (file) =>
  new Promise((resolve, _) => {
    const url = window.URL.createObjectURL(file);

    let width;
    let height;

    const img = new Image();
    img.onload = () => {
      width = img.naturalWidth;
      height = img.naturalHeight;
      window.URL.revokeObjectURL(url);

      resolve({ width, height });
    };
    img.src = url;
  });

export const resolveFileExtensionFromMime = (mime) => {
  if (!mime) {
    return mime;
  } else if (mime.toLowerCase().startsWith('image/')) {
    return mime.toLowerCase().replace('image/', '.');
  } else if (mime.toLowerCase().startsWith('application/')) {
    return mime.toLowerCase().replace('application/', '.');
  }
  // Add additional mime types here when required.
  else {
    return mime;
  }
};
